import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';


import accountingJournal from './journal';
import ProductJournal from './product-journal';
import ProductFinancialReport, { ProductReportDetails } from './product-report';

const System = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/default`} />
            <Route path={`${match.url}/journal`} component={accountingJournal} />
            <Route exact path={`${match.url}/product-journal`} component={ProductJournal} />
            <Route exact path={`${match.url}/product-report/details`} component={ProductReportDetails} />
            <Route exact path={`${match.url}/product-report`} component={ProductFinancialReport} />
            <Redirect to="/error" />
        </Switch>
    </div>
);
export default System;
